export default __webpack_public_path__ + "0f62354e6221e66d43160623868904c4.svg";